export default {
      id: "logo-en-usage",
      viewBox: "0 0 289.16 46.71",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#logo-en",
      toString: function () {
        return this.url;
      }
    }